import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"
import CamposOrden from "./CamposOrden.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Campos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Orden",
                    id: "ordenamiento",
                    accessor: d => d.ordenamiento,
                    width: 50,
                    show: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Obligatorio",
                    id: "obligatorio",
                    className: "text-center",
                    accessor: d => (d.obligatorio ? <div className="badge badge-success">OBLIGATORIO</div> : <div></div>),
                    filterable: false,
                    width: 100,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        let outerSort = [{"id":"ordenamiento","desc":false}]
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        permission: 'camposdeplan_add',
                        component: Create,
                    },
                    {
                        edit: true,
                        permission: 'camposdeplan_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'camposdeplan_detail',
                        component: Detail,
                    },
                    {
                        edit: true,
                        permission: 'camposdeplan_delete',
                        component: Delete,
                    },
                    {
                        edit: true,
                        permission: 'camposdeplan_edit',
                        component: CamposOrden,
                    }
                ]}

                apiUrl={api.proyectos.config.plan.campos.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.config.plan.campos.export}
                title={"Campos del Plan"}
                outerSort={outerSort}
            />
        );
    }
}

export default Campos;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_Campos/Campos.js